import { api } from "../api/api";

const errorHandler = (error) => {
  if (error?.code?.trim() === "ERR_NETWORK") {
    throw new Error(
      "It looks like we can't reach the server right now. Please try refreshing the page or check after sometime."
    );
  } else {
    throw new Error(error?.response?.data?.title);
  }
};

export const getKrogerRegions = async()=>{
    try{
        const response = await api.get(`/api/OrderActionConfig/TradingPartnerRegions`);
        return response.data?.result?.result || [];
    }catch(error){
        errorHandler(error);
    }
}

export const getKrogerOrderDeatils = async(params)=>{
    try{
    const response = await api.get(`/api/OrderActionConfig`, {params});
    return response.data?.result?.result || [];
    }catch(error){
        errorHandler(error);
    }
}

export const switchKrogerInvoice = async (id) => {
  try{
    const response = await api.put(`/api/OrderActionConfig/${id}/toggle`);
    return response.data?.result?.result || [];
  }catch(error){
    errorHandler(error);
  }
}

export const updateKrogerInvoiceConfig = async (payload) => {
  try{
    const response = await api.put(`/api/OrderActionConfig/${payload?.id}`, payload);
    return response.data?.result?.result || [];
  }catch(error){
    errorHandler(error);
  }
}